//
//
//
//
import articleBase from '../articleBase';
export default {
  name: 'kePu',
  components: {
    articleBase: articleBase
  }
};